import { UpdateGroupNameRequest } from '@/coreInfrastructureModule/axios/generated/groupManage';

/**
 * グループ名の変更のアダプタ
 */
export class UpdateGroupNameAdapter {
  /**
   * リクエストをAPI用に変換する
   * @param newGroupName - 新しいグループ名
   */
  public static adaptForRequest(newGroupName: string): UpdateGroupNameRequest {
    return {
      updateGroupNameInfo: {
        groupName: newGroupName,
      },
    };
  }
}
